export default __webpack_public_path__ + "static/media/ms.0723b2cc.png";